import {IValidator} from "./IValidator";

export class RequiredValidator implements IValidator {
    defaultErrorMessage: string = 'Field is required';

    isValid(fieldValue: any): boolean {
        return !!fieldValue;
    }
}



// WEBPACK FOOTER //
// ./validation/RequiredValidator.ts